import type { DeviceCategory, DeviceDefinition, DeviceType } from './types';

/**
 * Central lookup of device kinds (TD-010). The toolbox, the Properties panel and — later — the
 * scene loader and simulation world resolve device behavior exclusively through a registry.
 */
export class DeviceRegistry {
  private readonly definitions = new Map<DeviceType, DeviceDefinition>();

  /** Registers a definition. Registering the same type twice is a programming error. */
  register(definition: DeviceDefinition): this {
    if (this.definitions.has(definition.type)) {
      throw new Error(`Device type "${definition.type}" is already registered.`);
    }
    this.definitions.set(definition.type, definition);
    return this;
  }

  get(type: DeviceType): DeviceDefinition | undefined {
    return this.definitions.get(type);
  }

  has(type: DeviceType): boolean {
    return this.definitions.has(type);
  }

  /** Definitions in registration order, optionally filtered by category. */
  list(category?: DeviceCategory): readonly DeviceDefinition[] {
    const all = [...this.definitions.values()];
    return category === undefined
      ? all
      : all.filter((definition) => definition.category === category);
  }
}
